module.exports = __webpack_public_path__ + "img/christmas-2024.5cd819b8.png";